import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import event from '../../utils/piwik/event';
/**
 * `PiwikButton` wraps `Button` and logs a piwik event every time the button is
 * clicked. See the [piwik docs](https://piwik.org/docs/event-tracking/#tracking-events)
 * for information about what each prop `PiwikButton` supports maps to. Uses the
 * same theme key as `Button`.
 *
 * @public
 * @author Connor Taylor
 */

var PiwikButton =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(PiwikButton, _Component);

  function PiwikButton() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onClick", function (e) {
      var _this$props = _this.props,
          action = _this$props.action,
          name = _this$props.name,
          val = _this$props.val,
          onClick = _this$props.onClick,
          category = _this$props.category;
      event([category, action, name, val]);

      if (onClick) {
        onClick(e);
      }
    });

    return _this;
  }

  var _proto = PiwikButton.prototype;

  _proto.render = function render() {
    // Don't pass down unnecessary props
    var _this$props2 = this.props,
        action = _this$props2.action,
        name = _this$props2.name,
        val = _this$props2.val,
        category = _this$props2.category,
        rest = _objectWithoutPropertiesLoose(_this$props2, ["action", "name", "val", "category"]);

    return React.createElement(Button, _extends({}, rest, {
      onClick: this.onClick
    }), this.props.children);
  };

  return PiwikButton;
}(Component);

PiwikButton.defaultProps = {
  category: "click",
  action: "button"
};
export default PiwikButton;